import { gettext } from '@eventbrite/i18n';
import React from 'react';
import './BrowseContainer.scss';

export const ForYouTabKey: React.FunctionComponent = () => {
    return <span>{gettext('For you')}</span>;
};
